module.exports = __webpack_public_path__ + "static/media/electronics.636454df.svg";


//////////////////
// WEBPACK FOOTER
// ./src/scenes/Wizard/parts/images/new/electronics.svg
// module id = 3063
// module chunks = 0